var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@mui/material/styles/styled';
import { OutlinedInput as MuiOutlinedInput, outlinedInputClasses, } from '@mui/material';
var OutlinedInput = styled(MuiOutlinedInput)(function (_a) {
    var _b, _c, _d, _e, _f;
    var theme = _a.theme, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, size = _a.size;
    return __assign(__assign(__assign(__assign((_b = { backgroundColor: '#fff', padding: 0 }, _b[".".concat(outlinedInputClasses.notchedOutline)] = {
        borderColor: 'rgba(0,0,0,0.08)',
    }, _b["&:hover .".concat(outlinedInputClasses.notchedOutline)] = {
        borderColor: 'rgba(0,0,0,0.26)',
    }, _b["&.".concat(outlinedInputClasses.focused, " .").concat(outlinedInputClasses.notchedOutline)] = {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
    }, _b["&.".concat(outlinedInputClasses.error, " .").concat(outlinedInputClasses.notchedOutline)] = {
        borderColor: theme.palette.error.main,
    }, _b["&.".concat(outlinedInputClasses.disabled, " .").concat(outlinedInputClasses.notchedOutline)] = {
        borderColor: 'rgba(0, 0, 0, 0.08)',
        backgroundColor: theme.palette.action.disabledBackground
    }, _b), (startAdornment && (_c = {
            paddingLeft: 12
        },
        _c["& .".concat(outlinedInputClasses.input)] = {
            paddingLeft: 0,
        },
        _c))), (endAdornment && (_d = {
            paddingRight: 12
        },
        _d["& .".concat(outlinedInputClasses.input)] = {
            paddingRight: 0,
        },
        _d))), (_e = {}, _e["& .".concat(outlinedInputClasses.input)] = {
        padding: '12.5px 12px',
    }, _e)), (size === 'small' && (_f = {},
        _f["& .".concat(outlinedInputClasses.input)] = {
            padding: '8px 12px 8px 12px',
            fontSize: 14,
        },
        _f)));
});
export default OutlinedInput;
